import React from "react";

const relativeTime = (iso) => {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const diff = Math.max(0, Date.now() - then);
  const s = Math.floor(diff / 1000);
  if (s < 60) return "just now";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d}d ago`;
  return new Date(iso).toLocaleDateString();
};

const TRIGGER_LABELS = {
  run_tables: "Run Tables",
  "pre-restore": "Auto-saved before restore",
};

// Modal listing DataGroupVersion history for a project, with restore.
// Mirrors the visual style of ChangeLogModal.js.
const DataGroupVersionsModal = ({
  isOpen,
  onClose,
  versions = [],
  loading = false,
  busyId = null,
  onRestore,
}) => {
  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          padding: 20,
          borderRadius: 12,
          width: 520,
          maxHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 12,
          }}
        >
          <h4 style={{ margin: 0 }}>Datagroup Versions</h4>
          <button onClick={onClose} className="quota-modal-close-button">
            ×
          </button>
        </div>

        <div
          style={{
            flex: 1,
            overflowY: "auto",
            border: "1px solid #e5e7eb",
            borderRadius: 8,
          }}
        >
          {loading ? (
            <div style={{ fontSize: 13, color: "#888", padding: 24, textAlign: "center" }}>
              Loading versions…
            </div>
          ) : versions.length === 0 ? (
            <div style={{ fontSize: 13, color: "#888", padding: 24, textAlign: "center" }}>
              No versions saved yet. Versions are saved automatically each time you run tables.
            </div>
          ) : (
            versions.map((v, idx) => (
              <div
                key={v.id}
                style={{ borderBottom: "1px solid #f1f5f9" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    padding: "10px 12px",
                  }}
                >
                  <div
                    style={{
                      flexShrink: 0,
                      width: 30,
                      height: 30,
                      borderRadius: "50%",
                      background: idx === 0 ? "#2563eb" : "#94a3b8",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 12,
                      fontWeight: 700,
                    }}
                  >
                    v{v.version}
                  </div>

                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div
                      style={{
                        fontSize: 13.5,
                        fontWeight: 600,
                        color: "#1f2937",
                        wordBreak: "break-word",
                      }}
                    >
                      {TRIGGER_LABELS[v.trigger] || v.trigger}
                      {v.bannerName ? ` · ${v.bannerName}` : ""}
                      {idx === 0 && (
                        <span
                          style={{
                            marginLeft: 8,
                            padding: "1px 6px",
                            fontSize: 10.5,
                            fontWeight: 700,
                            color: "#166534",
                            background: "#dcfce7",
                            borderRadius: 4,
                          }}
                        >
                          LATEST
                        </span>
                      )}
                    </div>
                    <div style={{ fontSize: 11.5, color: "#6b7280", marginTop: 2 }}>
                      {v.createdBy || "Unknown"}
                      {" · "}
                      <span title={new Date(v.createdAt).toLocaleString()}>
                        {relativeTime(v.createdAt)}
                      </span>
                    </div>
                  </div>

                  <button
                    onClick={() => onRestore(v)}
                    disabled={idx === 0 || busyId === v.id}
                    title={idx === 0 ? "Already the current version" : "Restore this version"}
                    style={{
                      flexShrink: 0,
                      fontSize: 12,
                      padding: "4px 10px",
                      borderRadius: 6,
                      border: "1px solid #cbd5e1",
                      background: idx === 0 ? "#f1f5f9" : "#fff",
                      color: idx === 0 ? "#94a3b8" : "#334155",
                      cursor: idx === 0 || busyId === v.id ? "not-allowed" : "pointer",
                    }}
                  >
                    {busyId === v.id ? "…" : "Restore"}
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 10 }}>
          A new version is saved automatically every time you run tables. Restoring saves the
          current datagroup as a new version first, so restores can be undone.
        </div>
      </div>
    </div>
  );
};

export default DataGroupVersionsModal;
